var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOpenApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.76 74.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.91,0h-44.5c-3.73,0-6.85,3.12-6.85,6.85v11.38c0,1,.39,1.97,1.1,2.68.71.71,1.67,1.12,2.68,1.12,1.01,0,1.98-.39,2.69-1.11.71-.71,1.11-1.68,1.11-2.69V7.58h43.04v59.04h-43.04v-10.99c0-1.01-.4-1.98-1.11-2.69-.71-.71-1.68-1.11-2.69-1.11-1,0-1.97.41-2.68,1.12-.71.71-1.1,1.68-1.1,2.68v11.72c0,3.73,3.12,6.85,6.85,6.85h44.5c3.73,0,6.85-3.12,6.85-6.85V6.85c0-3.73-3.12-6.85-6.85-6.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.48,47.24c-.72.7-1.14,1.65-1.16,2.65-.02,1,.36,1.97,1.05,2.69.7.73,1.65,1.15,2.66,1.17,1.01.02,1.98-.36,2.71-1.06l11.91-11.52c2.23-2.16,2.23-5.98,0-8.14l-11.91-11.52c-.75-.73-1.78-1.11-2.82-1.06h0c-.96.05-1.87.46-2.54,1.15-.7.73-1.08,1.7-1.06,2.71.02,1.01.44,1.97,1.17,2.66l6.54,6.35H3.8c-1,0-1.97.39-2.68,1.1C.41,35.12,0,36.08,0,37.09c0,1.01.4,1.98,1.11,2.69.71.71,1.68,1.11,2.69,1.11h44.23l-6.56,6.35Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenApp);
export default __webpack_public_path__ + "static/media/icon-open-app.1ea5a96da2f795321a6f609f4bfd8079.svg";
export { ForwardRef as ReactComponent };